import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TenOption from './option';
import TenOptions from './options';
import { getLabelPathStrByModel } from './cascader-utils';

export default class ReactComponent extends Component {
  static propTypes = {
    options: PropTypes.array,
    title: PropTypes.string,
    index: PropTypes.number,
    isFilterMode: PropTypes.bool,
    renderLabel: PropTypes.func,
    menuBlur: PropTypes.func,
    loading: PropTypes.bool,
    showFilter: PropTypes.bool,
  };
  static defaultProps = {
    index: 0,
  };
  static contextTypes = {
    tenCascaderPanel: PropTypes.object,
  };
  tenOptions = null;
  isExpanded = (model) => {
    const { expandedNodes } = this.context.tenCascaderPanel.state;
    return expandedNodes.indexOf(model) > -1;
  };

  isSelected = (model) => {
    const { multiple, independent } = this.context.tenCascaderPanel.props;
    if (multiple || independent) {
      return model.selected === 1;
    }
    return model.isLeaf && model.selected === 1;
  };

  getLabel(model) {
    const { optionLabel } = this.context.tenCascaderPanel.props;

    if (this.props.renderLabel) {
      return this.props.renderLabel(model);
    }

    return model.data[optionLabel];
  }

  getSuffixIcon = (model) => {
    if (this.props.isFilterMode) {
      return '';
    }

    if (!model.isLeaf) {
      return model.loading ? 'loading_gradient' : 'right';
    }

    return '';
  };

  select(model) {
    if (model.data.disabled) {
      return;
    }
    const { multiple } = this.context.tenCascaderPanel.props;

    // eslint-disable-next-line
    const selected = multiple ? (model.selected === 1 ? 0 : 1) : 1;
    this.context.tenCascaderPanel.onNodeSelect(model, selected);
  }

  expand(model) {
    if (model.data.disabled) {
      return;
    }

    if (this.props.isFilterMode) {
      return;
    }

    this.context.tenCascaderPanel.onNodeExpand(model, this.props.index);
  }

  focus(index) {
    let focusIndex;

    if (typeof index !== 'undefined') {
      focusIndex = index;
    } else if (this.tenOptions.focusIndex === -1) {
      focusIndex = 0;
    }

    this.tenOptions.focus(focusIndex);
  }

  blur() {
    this.tenOptions.blur();
  }

  onItemFocus(model) {
    this.expand(model);
  }

  onItemClick = (model) => {
    const { expandTrigger } = this.context.tenCascaderPanel.props;

    if (expandTrigger === 'click') {
      this.expand(model);
    }

    if (model.isLeaf || this.props.isFilterMode) {
      this.select(model);
    }
  };

  onItemMouseover = (model) => {
    const { expandTrigger } = this.context.tenCascaderPanel.props;

    if (expandTrigger === 'hover') {
      this.expand(model);
    }
  };

  onItemSelect = (model) => {
    this.select(model);

    if (!model.isLeaf) {
      this.expand(model);
    }
  };

  onOptionKeyCommand(model, type) {
    const { menuBlur } = this.props;
    switch (type) {
      case 'enter':
        if (model.isLeaf || this._multiple) {
          this.select(model);
        }

        break;

      case 'left':
        menuBlur('left');
        break;

      case 'right':
        menuBlur('right');
        break;
    }
  }

  renderOptionContent(model) {
    const { showFilter, optionLabel, separator, renderOption } = this.props;

    if (showFilter) {
      return getLabelPathStrByModel(model, optionLabel, separator);
    }

    const option = model.data;
    if (renderOption) {
      return renderOption(option);
    }
    return `${option[optionLabel]}`;
  }

  shouldMultipleCheck = (model) => {
    const { multiple, onlyLeafSelectable } = this.context.tenCascaderPanel.props;

    if (!multiple) return false;
    return onlyLeafSelectable ? model.isLeaf : true;
  };

  render() {
    const { loading, isFilterMode, options, title } = this.props;
    const { props: { multiple, independent, emptyTip } = {} } = this.context.tenCascaderPanel || {};
    const showRadio = independent && !isFilterMode;
    return (
      <div className="ten-cascader-menu">
        {title && <h5 className="ten-cascader-menu__title"> {title} </h5>}
        <TenOptions
          showCheckbox={multiple}
          showRadio={showRadio}
          empty={options.length === 0}
          loading={loading}
          emptyTip={emptyTip}
        >
          {options.map((model) => (
            <TenOption
              ref={(el) => {
                this.tenOptions = el;
              }}
              showCheckbox={this.shouldMultipleCheck(model)}
              active={this.isExpanded(model)}
              selected={this.isSelected(model)}
              disabled={model.data.disabled}
              indeterminate={model.status.selected === 2}
              suffixIcon={this.getSuffixIcon(model)}
              loading={model.loading}
              onMouseOver={() => this.onItemMouseover(model)}
              onSelect={() => this.onItemSelect(model)}
              optionClick={() => this.onItemClick(model)}
              optionKeyCommand={(type) => {
                this.onOptionKeyCommand(model, type);
              }}
              showRadio={showRadio}
              model={model}
              key={model.id}
            >
              {this.renderOptionContent(model)}
            </TenOption>
          ))}
        </TenOptions>
      </div>
    );
  }
}
